import React, { useState } from "react";
import {
  Modal,
  ModalBody,
  ModalHeader,
  Input,
  Button,
  Row,
  Col,
  FormGroup,
  Label,
  FormFeedback,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import usePersistStoreData from "../Hooks/usePersistStoreData";
import { Formik, Field, ErrorMessage, Form } from "formik";
import * as Yup from "yup";

const EditNameModal = ({ edit_name, close_editName }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userData } = usePersistStoreData();
  const token = userData?.token;
  const FILE_SIZE = 2 * 1024 * 1024; // 2MB
  const SUPPORTED_FORMATS = ["application/pdf", "image/jpeg"];

  const initialValues = {
    user_name: "",
    user_name_document: "",
  };
  const validationSchema = Yup.object({
    user_name: Yup.string()
      .matches(/^[A-Za-z ]*$/, "Only alphabets are allowed")
      .required("Name is required!"),
    user_name_document: Yup.mixed()
      .required("Document is required")
      .test("fileType", "Only PDF or JPEG files are allowed", (value) => {
        return value && SUPPORTED_FORMATS.includes(value.type);
      })
      .test("fileSize", "File size must be less than 2 MB", (value) => {
        return value && value.size <= FILE_SIZE;
      }),
  });

  return (
    <Modal isOpen={edit_name} centered={true} className="contact_modal_custom">
      <ModalHeader
        toggle={close_editName}
        style={{
          backgroundColor: "#0F528D",
          paddingTop: "0.75rem",
          paddingBottom: "0.75rem",
        }}
      >
        <span className="fs-16 contact_note_header ">Edit Name</span>
      </ModalHeader>
      <ModalBody className="">
        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            console.log("Form values:", values);
            close_editName();
          }}
        >
          {(formik) => (
            <Form onSubmit={formik.handleSubmit}>
              <ModalBody className="p-0">
                <Row className="row m-0 p-0">
                  <Col xxl={12} className="ps-0">
                    <FormGroup>
                      <Label for="user_name">Name *</Label>
                      <Input
                        type="text"
                        name="user_name"
                        id="user_name"
                        className="form-control"
                        placeholder="Enter new name"
                        value={formik.values.user_name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        invalid={
                          formik.touched.user_name && !!formik.errors.user_name
                        }
                      />
                      <FormFeedback>{formik.errors.user_name}</FormFeedback>
                    </FormGroup>
                  </Col>

                  <Col xxl={12} className="ps-0">
                    <FormGroup>
                      <Label for="user_name_document">
                        Upload Documents-pdf, jpeg (Passport / Marriage Certificate) *
                      </Label>
                      <Input
                        type="file"
                        name="user_name_document"
                        id="user_name_document"
                        className="form-control"
                        accept="application/pdf, image/jpeg"
                        onChange={(e) => {
                          const file = e.currentTarget.files[0];
                          formik.setFieldValue("user_name_document", file);
                        }}
                        onBlur={formik.handleBlur}
                        invalid={
                          formik.touched.user_name_document &&
                          formik.errors.user_name_document
                        }
                      />

                      <FormFeedback>
                        {formik.errors.user_name_document}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                </Row>
              </ModalBody>
              <div className="centerContent">
                <Button
                  className="fs-16"
                  color="primary"
                  type="submit"
                  style={{
                    minWidth: "120px",
                  }}
                >
                  Save
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </ModalBody>
    </Modal>
  );
};

export default EditNameModal;
